// React imports.
import React from "react";

import { Assessment3StepsEnum } from "../state";


const Assessment3TopParagraph = ({fuelType, supplementalAssessmentType, resultFlag }) => (
    <React.Fragment>
        {supplementalAssessmentType === 1 &&
            <React.Fragment>
                <p>
                    <strong>Supplemental Investigation 1 – Requesting Data{(resultFlag===true)&&<React.Fragment>&nbsp;Result</React.Fragment>}</strong>
                </p>
                <p>
                    It’s possible that you were unable to collect main heating expenditure data
                    from enough&nbsp;{fuelType.descriptionHeat}  households because the vendors from whom you requested data
                    do not serve at least&nbsp;{fuelType.targetPercentHouseholdsCoveredString} of your {fuelType.description} Households. In the table below, please
                    enter the number of households represented by the {fuelType.description}&nbsp;vendors from whom you
                    requested main heating expenditure data.
                </p>
                <p>
                    Note: This information is not reported in your Performance Data form.
                    You will need to have your IT staff pull this information from
                    your data base.
                </p>
            </React.Fragment>
        }
        {supplementalAssessmentType === 2 &&
            <React.Fragment>
                  <p>
                      <strong>Supplemental Investigation 2 – Receiving Data{(resultFlag===true)&&<React.Fragment>&nbsp;Result</React.Fragment>}</strong>
                  </p>
                  <p>
                      Even if you requested data from enough vendors to represent at least {fuelType.targetPercentHouseholdsCoveredString} of your
                      &nbsp;{fuelType.descriptionHeat}&nbsp; 
                      households, you may still have an issue if enough of those vendors DO NOT
                      comply with your request. In the table below, please enter the number of households
                      represented by the&nbsp;{fuelType.description}&nbsp;vendors from whom data was actually received.
                  </p>
                  <p>
                      Note: This information is not reported in your Performance Data form. You will need to have
                      your IT staff pull this information from your data base
                  </p>
              
              </React.Fragment>
          }
          {supplementalAssessmentType === 3 &&
              <React.Fragment>
                  <p>
                      <strong>Supplemental Investigation 3 – Rate of Return{(resultFlag===true)&&<React.Fragment>&nbsp;Result</React.Fragment>}</strong>
                  </p>
                  <p>
                      If the vendors from whom you received data represent at least&nbsp;{fuelType.targetPercentHouseholdsCoveredString} of LIHEAP assisted {fuelType.descriptionHeat}&nbsp; 
                       households, but you still have not collected data for at least {fuelType.targetPercentHouseholdsCoveredString} of your&nbsp;
                      {fuelType.descriptionHeat}  households, then it is likely that your vendors are not submitting
                      complete data for an adequate percentage of their households. 
                  </p>
                  <p>
                      Vendors who receive a data request should be able to furnish data for at least 75% of
                      the total number of households they serve. We have used information that you have
                      already entered to auto-fill the total number enter the number of&nbsp;{fuelType.descriptionHeat}&nbsp; 
                      households for whom you actually received data.	
                  </p>
              </React.Fragment>
          }
    </React.Fragment>
);
export default Assessment3TopParagraph;
